import type React from 'react';
import {convertToLink} from '../../../../../../shared/services/convertToLink';

export const NotesText: React.FC<{children: string}> = ({children}) => {
  return (
    <span className="text-xs pc:text-sm break-all">
      {convertToLink(children)}
    </span>
  );
};
